/* eslint-disable react/forbid-prop-types */
import PropTypes from "prop-types";
import classNames from "classnames";
import styled from "styled-components";

// Inline activateable buttons. Maximum 1 active button at a time.
export function OptionsButton({ structure, activeValue, onChange }) {
    // accommodate single onChange callback
    if (onChange) {
        structure = structure.map((item) => ({ ...item, onClick: onChange }));
    }

    const buttons = structure.map(({ value, label, onClick }) => (
        <button
            type="button"
            key={value}
            className={classNames(["btn", { "btn-secondary active": value === activeValue }])}
            onClick={onClick.bind(null, value)}
        >
            {label}
        </button>
    ));
    return (
        <ButtonStyles>
            {buttons}
        </ButtonStyles>
    );
}

// Support either per-item onClick, OR a single onChange that receives the clicked "value"
OptionsButton.propTypes = {
    onChange: PropTypes.func,
    activeValue: PropTypes.any.isRequired, // value of the active button. Should `===` one of the values in structure.
    structure: PropTypes.arrayOf(PropTypes.shape({ // each renders a separate button.
        value: PropTypes.any, // passed to onClick
        label: PropTypes.string // displayed button text
    })).isRequired
};

OptionsButton.defaultProps = {
    onChange: false
};

const ButtonStyles = styled.div`
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    
    .active + .btn {
        border-left-width: 0;
    }
    
    .btn {
        margin: 0;
        padding: 6px 8px;
        outline: none;
        border-left-width: 1px;
        border-radius: 0;
        border-right-width: 0;
        border-color: ${(props) => props.theme.colors["paz-black-l-30"]};
        background-color: ${(props) => props.theme.colors["canvas-white"]};

        &.btn-secondary.active {
            color: ${(props) => props.theme.colors["blue-wcag-327"]};
            border-color: ${(props) => props.theme.colors["blue-wcag-327"]};
            background-color: ${(props) => props.theme.colors["blue-tint"]};
            box-shadow: inset 0px 3px 5px 0px rgb(50, 120, 179, 0.2);
            border-left-width: 1px;
            border-right-width: 1px;
        }
      
        &:hover {
            background-color: ${(props) => props.theme.colors["canvas-dark"]};
        }

        &:first-child {
            border-left-width: 1px;
            border-radius: 3px 0 0 3px;
        }

        &:last-child {
            border-right-width: 1px;
            border-radius: 0 3px 3px 0;
        }

        &:last-child:first-child {
            border-right-width: 1px;
            border-left-width: 1px;
            border-radius: 3px;
        }
    }
`;
